"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ILCardActionAssignment = void 0;
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var il_card_assignment_1 = require("../il-card-assignment/il-card-assignment");
var icon_1 = require("../icon/icon");
var enums_1 = require("../../shared/enums");
var typeography_common_1 = require("../typeography/typeography.common");
var helpers_1 = require("../../shared/helpers");
function ILCardActionAssignment(_a) {
    var sx = _a.sx, className = _a.className, assignmentType = _a.assignmentType, assignmentState = _a.assignmentState, assignmentTitle = _a.assignmentTitle, dueDate = _a.dueDate, scoreMessage = _a.scoreMessage, _b = _a.dateToday, dateToday = _b === void 0 ? new Date() : _b, onClick = _a.onClick;
    var dueDateString = (0, helpers_1.formatDueDateString)(dueDate, dateToday, 'MMM do');
    var iconProps = {
        icon: enums_1.IconEnum.CIRCLE_PLAY,
        size: enums_1.IconSizeEnum.XXSMALL,
        sx: {
            maxWidth: '1.375rem',
            maxHeight: '1.375rem',
            color: 'primary.dark',
        },
    };
    var color = 'text.primary';
    var icon = undefined;
    switch (assignmentState) {
        case enums_1.AssignmentStateEnum.OVERDUE: {
            iconProps.icon = enums_1.IconEnum.CIRCLE_X;
            iconProps.sx.color = color = 'error.main';
            dueDateString = "Overdue | ".concat(dueDateString);
            icon = enums_1.IconEnum.OVERDUE;
            break;
        }
        case enums_1.AssignmentStateEnum.COMPLETED: {
            iconProps.icon = enums_1.IconEnum.CIRCLE_CHECK;
            iconProps.sx.color = color = '#5FA900';
            break;
        }
        default: {
            break;
        }
    }
    if (scoreMessage) {
        icon = enums_1.AssignmentStateEnum.OVERDUE === assignmentState ? enums_1.IconEnum.X_MARK : enums_1.IconEnum.CHECK;
    }
    return (react_1.default.createElement(material_1.Card, { className: 'il-card-actions-assignment ' + className, sx: __assign({ display: 'flex', flexDirection: 'row', gap: { xs: 0, md: '0.9375rem' } }, sx) },
        react_1.default.createElement(material_1.Box, { "data-testid": 'left-panel', sx: {
                ml: { xs: '0.5rem', md: '1.25rem' },
                position: 'relative',
                display: 'flex',
                justifyContent: 'center',
                alignContent: 'center',
                alignItems: 'center',
                '&::before': {
                    content: "''",
                    position: 'absolute',
                    top: 0,
                    left: '50%',
                    borderLeft: '0.125rem solid',
                    borderLeftColor: 'text.disabled',
                    background: 'text.disabled',
                    height: '100%',
                },
            } },
            react_1.default.createElement(material_1.IconButton, { size: "small", disabled: !onClick, onClick: onClick, sx: {
                    bgcolor: 'background.paper',
                    opacity: 1,
                    '&:hover': { opacity: 1, bgcolor: 'action.disabledBackground' },
                    '&.Mui-disabled': { opacity: 1, bgcolor: 'background.paper' },
                } },
                react_1.default.createElement(icon_1.Icon, __assign({}, iconProps)))),
        react_1.default.createElement(material_1.Box, { "data-testid": 'center-panel', sx: __assign(__assign({ width: '100%', pt: '0.75rem', pb: '0.8125rem', '& h6': {
                    whiteSpace: 'break-spaces',
                } }, il_card_assignment_1.ilAssignmentDescriptionSx), { flex: 'unset' }) },
            react_1.default.createElement(material_1.Box, { sx: { display: 'flex', justifyContent: 'space-between' } },
                react_1.default.createElement(il_card_assignment_1.IlAssignmentContentDescription, { assignmentType: assignmentType }),
                react_1.default.createElement(material_1.Box, { sx: {
                        display: 'flex',
                        alignContent: 'center',
                        pr: '0.875rem',
                        gap: { xs: '0.125rem', md: '0.25rem' },
                        color: color,
                    } },
                    react_1.default.createElement(typeography_common_1.ILCaption, { sx: { color: 'inherit', lineHeight: '0.9rem', fontWeight: 600 } }, scoreMessage !== null && scoreMessage !== void 0 ? scoreMessage : dueDateString),
                    icon && (react_1.default.createElement(icon_1.Icon, { icon: icon, size: enums_1.IconSizeEnum.XXSMALL, sx: {
                            '& svg': {
                                width: '0.875rem',
                                height: '0.875rem',
                            },
                        }, dataTestId: "header-icon" })))),
            react_1.default.createElement(typeography_common_1.ILH6, { sx: __assign(__assign({}, il_card_assignment_1.truncateSx), { color: 'black' }) }, assignmentTitle))));
}
exports.ILCardActionAssignment = ILCardActionAssignment;
